import { render, staticRenderFns } from "./UnidadeMedida.vue?vue&type=template&id=40848bd2&scoped=true"
import script from "./UnidadeMedida.vue?vue&type=script&lang=js"
export * from "./UnidadeMedida.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedida.vue?vue&type=style&index=0&id=40848bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40848bd2",
  null
  
)

export default component.exports